import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const ROLES = {
  ADMIN:              'admin',
  COMPANY_HEAD:       'company_head',
  METALLIC_MASTER:    'metallic_master',
  LOADING_SUPERVISOR: 'loading_supervisor',
}

export const isAdmin       = (r) => [ROLES.ADMIN, ROLES.COMPANY_HEAD].includes(r)
export const isMetallicMaster  = (r) => r === ROLES.METALLIC_MASTER
export const isLoadingSupervisor = (r) => r === ROLES.LOADING_SUPERVISOR

export const useAuthStore = create(
  persist(
    (set) => ({
      user:            null,   // { id, name, role, unitId, unitName }
      token:           null,
      isAuthenticated: false,

      login:  (user, token) => set({ user, token, isAuthenticated: true }),
      logout: ()            => set({ user: null, token: null, isAuthenticated: false }),
    }),
    { name: 'jaritex-auth' }
  )
)
